<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='/archive-discard'>{{translations('navbar.inventory_control')}}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-discard'>{{translations('discard.archive_discard')}}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('discard.discard_detail')}}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
            <tr>
              <th>{{translations('discard.division')}}</th>
<!--              <td v-show="(Number(discardInfo.is_processed) === 0)">-->
<!--                <button-->
<!--                  ref='info01'-->
<!--                  type='button'-->
<!--                  class='btn btn-link p-0'-->
<!--                  data-toggle='popover-x'-->
<!--                  data-target='#popover-info01'-->
<!--                  data-placement='right'-->
<!--                >-->
<!--                  {{ translations(`discard.${tempInfo.division_type}`) || '&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;' }}-->
<!--                </button>-->
<!--                <div id='popover-info01' class='popover popover-x popover-default'>-->
<!--                  <div class='arrow'></div>-->
<!--                  <div class='popover-header popover-title'>-->
<!--                    <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('discard.division')}}-->
<!--                  </div>-->
<!--                  <div class='popover-body popover-content'>-->
<!--                    <select-->
<!--                      class='form-control'-->
<!--                      v-model="tempInfo.division_type_select">-->
<!--                      <option-->
<!--                        v-for="type in translatedDivisionTypes"-->
<!--                        :key="type.value"-->
<!--                        :value="type.value"-->
<!--                      >-->
<!--                        {{ type.label }}-->
<!--                      </option>-->
<!--                    </select>-->
<!--                  </div>-->
<!--                  <div class='popover-footer'>-->
<!--                    <button type='submit' class='btn btn-sm btn-primary' @click="updateField('division_type', tempInfo.division_type_select, 'info01')">{{translations('common.update')}}</button>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </td>-->
<!--               <td v-show="(Number(discardInfo.is_processed) === 1)">{{ translations(`discard.${tempInfo.division_type}`) || '&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;' }}</td>-->
              <td>{{ translations(`discard.${tempInfo.division_type}`) || '----------' }}</td>
            </tr>
            <tr>
              <th>{{translations('discard.application_date')}}</th>
              <td v-show="(Number(discardInfo.is_processed) === 0)">
                <button
                  ref='info02'
                  type='button'
                  class='btn btn-link p-0'
                  data-toggle='popover-x'
                  data-target='#popover-info02'
                  data-placement='right'
                >{{ discardInfo.apply_date ? $invoiceTools.formatDateHours(discardInfo.apply_date) : '--------------' }}</button>
                <div id='popover-info02' class='popover popover-x popover-default'>
                  <div class='arrow'></div>
                  <div class='popover-header popover-title'>
                    <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('discard.application_date')}}
                  </div>
                  <div class='popover-body d-flex'>
                    <input type='date' v-model='date_apply' class='form-control input-date'>
                    <input type='time' v-model='time_apply' class='form-control input-time'>
                  </div>
                  <div class='popover-footer'>
                    <button type='submit' class='btn btn-sm btn-primary' @click="updateField('apply_date', `${date_apply} ${time_apply}`, 'info02')">{{translations('common.update')}}</button>
                  </div>
                </div>
              </td>
              <td v-show="(Number(discardInfo.is_processed) === 1)">{{$invoiceTools.formatDateHours(discardInfo.apply_date)}}</td>
            </tr>
            <tr>
              <th>{{translations('discard.disposal_date')}}</th>
              <td v-show="(Number(discardInfo.is_processed) === 0)">
                <button
                  ref='info03'
                  type='button'
                  class='btn btn-link p-0'
                  data-toggle='popover-x'
                  data-target='#popover-info03'
                  data-placement='right'
                >{{ discardInfo.discard_date ? $invoiceTools.formatDateHours(discardInfo.discard_date) : '--------------' }}</button>
                <div id='popover-info03' class='popover popover-x popover-default'>
                  <div class='arrow'></div>
                  <div class='popover-header popover-title'>
                    <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('discard.disposal_date')}}
                  </div>
                  <div class='popover-body d-flex'>
                    <input type='date' v-model='date_discard' class='form-control input-date'>
                    <input type='time' v-model='time_discard' class='form-control input-time'>
                  </div>
                  <div class='popover-footer'>
                    <button type='submit' class='btn btn-sm btn-primary' @click="updateField('discard_date', `${date_discard} ${time_discard}`, 'info03')">{{translations('common.update')}}</button>
                  </div>
                </div>
              </td>
              <td v-show="(Number(discardInfo.is_processed) === 1)">{{$invoiceTools.formatDateHours(discardInfo.discard_date)}}</td>
            </tr>
            <tr>
              <th>{{translations('discard.organization_number')}}</th>
              <td>{{discardInfo.discard_number}}</td>
            </tr>
            <tr>
              <th>{{translations('discard.applicant')}}</th>
              <td>
                <button
                  ref='info04'
                  type='button'
                  class='btn btn-link p-0'
                  data-toggle='popover-x'
                  data-target='#popover-info04'
                  data-placement='right'
                >{{ discardInfo.requester_name ? discardInfo.requester_name : '--------------' }}</button>
                <div v-if="master_personnel" ref="popover-info04" id='popover-info04' class='popover popover-x popover-default popover-fit-content'>
                  <div class='arrow'></div>
                  <div class='popover-header popover-title'>
                    <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('discard.applicant')}}
                  </div>
                  <div class='popover-body popover-content'>
                    <p style="position:absolute;left:-10000px">{{ forceChange }}</p>
                    <v-select :options="master_personnel" label="name" value="id" v-model="tempInfo.requester" @input="setSelectedRequester"></v-select>
                  </div>
                  <div class='popover-footer'>
                    <button type='submit' class='btn btn-sm btn-primary' @click="updateField('requester_id', tempInfo.requester, 'info04')">{{translations('common.update')}}</button>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>{{translations('discard.manufacturer')}}</th>
              <td>{{ discardInfo.partner_name }}</td>
            </tr>

            <tr>
              <th>{{translations('discard.warehouse')}}</th>
              <td>{{ discardInfo.warehouse_name ? discardInfo.warehouse_name : '--------------' }}</td>
            </tr>

            <tr>
              <th>{{translations('discard.reason')}}</th>
              <td>
                <button
                  ref='info07'
                  type='button'
                  class='btn btn-link p-0'
                  data-toggle='popover-x'
                  data-target='#popover-info07'
                  data-placement='right'
                >{{ discardInfo.reason ? discardInfo.reason : '--------------' }}</button>
                <div ref="popover-info07" id='popover-info07' class='popover popover-x popover-default popover-fit-content'>
                  <div class='arrow'></div>
                  <div class='popover-header popover-title'>
                    <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('discard.reason')}}
                  </div>
                  <div class='popover-body popover-content'>
                    <select
                      class='form-control'
                      v-model="tempInfo.reason">
                      <option
                        v-for="type in reasons"
                        :key="type.key"
                        :value="type.value"
                      >
                        {{type.value}}
                      </option>
                    </select>
                  </div>
                  <div class='popover-footer'>
                    <button type='submit' class='btn btn-sm btn-primary' @click="updateField('reason', tempInfo.reason, 'info07')">{{translations('common.update')}}</button>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>{{translations('discard.remarks')}}</th>
              <td>
                <button
                  ref='info08'
                  type='button'
                  class='btn btn-link p-0'
                  data-toggle='popover-x'
                  data-target='#popover-info08'
                  data-placement='right'
                >{{ discardInfo.memo || '----------' }}</button>
                <div id='popover-info08' class='popover popover-x popover-default'>
                  <div class='arrow'></div>
                  <div class='popover-header popover-title'>
                    <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('discard.remarks')}}
                  </div>
                  <div class='popover-body popover-content'>
                    <input type='text' v-model="tempInfo.memo" class='form-control'>
                  </div>
                  <div class='popover-footer'>
                    <button type='submit' class='btn btn-sm btn-primary' @click="updateField('memo', tempInfo.memo, 'info08')">{{translations('common.update')}}</button>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>{{translations('common.last_updated_by')}}</th>
              <td>{{discardInfo.updated_by}}</td>
            </tr>
            <tr>
              <th>{{translations('common.last_update_time')}}</th>
              <td>{{discardInfo.updated_at}}</td>
            </tr>
            <tr>
              <th class="is_processed">{{ translations('discard.processing_status') }}</th>
              <td>
                <button type="button" class="btn btn-primary btn-sm" v-if="Number(discardInfo.is_processed) === 0" v-on:click="clickIsProcessed()">
                  {{ translations('discard.mark_processed') }}</button>
                <button type="button" class="btn btn-primary btn-sm" v-else v-on:click="clickIsProcessed()">{{ translations('discard.revert_unprocessed') }}</button>
              </td>
            </tr>
            </tbody>
          </table>
          <hr>
          <div class='form-inline'>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger' @click.self="deleteDiscards()" data-href='#'>{{translations('common.delete')}}</a>
            </div>
          </div>
        </div>
        <div class='right-container'>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-1100'>
              <thead>
              <tr>
                <th></th>
                <th>{{translations('discard.commodity_condition')}}</th>
                <th>{{translations('discard.jan_code')}}</th>
                <th>{{translations('discard.model')}}</th>
                <th>{{translations('discard.tax_classification')}}</th><!-- TAXSTATUS -->
                <th>{{translations('discard.quantity')}}</th>
                <th class="width-50-px">{{translations('discard.unit_price')}}</th>
                <th>{{translations('discard.product_cost')}}</th>
                <th>No.</th>
                <th>{{translations('discard.summary')}}</th>
                <th>{{translations('discard.unit_price_total')}}</th>
                <th>{{translations('discard.total_cost')}}</th>
                <th>{{translations('discard.total_profit')}}</th>
              </tr>
              </thead>
              <tbody class="nowrap">
              <template v-for="(detail, i) in discardsDetails">
                <tr :key="i">
                  <td>
                    <button @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                  </td>
                  <td>{{ Number(detail.product_condition) === 2 ? translations('discard.outlet') : Number(detail.product_condition) === 1 ? translations('discard.bad') : translations('discard.good') }}</td>
                  <td>{{ detail.jan_code }}</td>
                  <td>{{ detail.model }}</td>
                  <td v-if="Number(discardInfo.is_processed) === 0">
                    <select
                      v-model="detail.taxclass_id"
                      v-validate="'required'"
                      data-vv-name="taxclass_id"
                      data-vv-as="税区分"
                      class="custom-select width-100-px"
                      required
                      @change="onchangeTaxclass">
                      <option value="1">{{translations('discard.taxable_item')}}</option>
                      <option value="2">{{translations('discard.not_applicable')}}</option>
                    </select>
                  </td><!-- TAXSTATUS -->
                  <td v-else>{{ Number(detail.taxclass_id) === 1 ? translations('discard.taxable_item') : translations('discard.not_applicable') }}</td>
                  <td style="min-width:80px;">
                    <input :readonly="(Number(discardInfo.is_processed) === 1)"
                           type="text" @input="numbers(i,'quantity')"
                           class="form-control form-control-sm" style="width:4em;"
                           v-on:keyup="quantityKeyUp($event,detail)"
                           v-model="detail.quantity"/>
                  </td>
                  <td v-show="Number(detail.taxclass_id) === 1" class="right">
                    <input readonly
                           type="text"
                           @input="numbers(i,'unit_price_inctax')"
                           class="form-control form-control-sm"
                           style="width:6em;"
                           v-model="detail.unit_price_inctax"/>
                  </td>
                  <td v-show="Number(detail.taxclass_id) === 2" class="right">
                    <input readonly
                           type="text"
                           @input="numbers(i,'unit_price')"
                           class="form-control form-control-sm"
                           style="width:6em;"
                           v-model="detail.unit_price"/>
                  </td>
                  <td class="right">
                    <input readonly
                           type="text"
                           @input="numbers(i,'row_price')"
                           class="form-control form-control-sm"
                           style="width:6em;" v-model="detail.row_price"/>
                  </td>
                  <td class="right">
                    <input type="text"
                           class="form-control form-control-sm"
                           style="width:10em;"
                           v-model="detail.client_order_number"/>
                  </td>
                  <td class="right">
                    <input type="text"
                           class="form-control form-control-sm"
                           style="width:10em;"
                           v-model="detail.remarks"/>
                  </td>
                  <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                  <td class="right">{{ toTaxFormat(detail, 'total_cost') }}</td>
                  <td class="right">{{ toTaxFormat(detail, 'total_profit') }}</td>
                </tr>
              </template>
              <tr class='bg-lightgreen'>
                <td v-if="(Number(discardInfo.is_processed) === 0)">
                  <button @click="openAddDetailModal()" class='btn-change plus' type='button'><i></i></button>
                  <button ref="openAddDetailModal" hidden="true" class='btn-change plus' type='button' data-toggle='modal' data-target='#NewDiscardsModal'><i></i></button>
                </td>
                <td v-else></td>
                <td colspan="9"></td>
                <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalUnitPrice, grandTotalUnitPriceIncTax) }}</td>
                <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalCost, grandTotalCostIncTax) }}</td>
                <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalProfit, grandTotalProfitIncTax) }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group'>
              <button class='btn btn-sm btn-primary mr-3' @click="updateDiscards()">{{translations('common.update')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewDiscardsModal
      :discardDetails='discardsDetails'
      :partnerId="tempInfo.manufacturer"
      :warehouseId="tempInfo.warehouse"
      :applyDate="tempInfo.apply_date"
      :divisionType="tempInfo.division_type_select"
    />
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import NewDiscardsModal from '@/components/NewDiscardsModal'
import { mapState } from 'vuex'
import { format } from 'date-fns'

export default {
  name: 'SingleDiscard',
  props: {},
  components: {
    VueElementLoading,
    NewDiscardsModal
  },

  data () {
    return {
      taxRate: 0, // VAT
      taxIncluded: false, // VAT
      discardsID: 0,
      destinations: [],
      discardInfo: {},
      discardsDetails: [],
      tempInfo: {},
      grandTotalUnitPrice: 0,
      grandTotalUnitPriceIncTax: 0,
      grandTotalCost: 0,
      grandTotalCostIncTax: 0,
      grandTotalProfit: 0,
      grandTotalProfitIncTax: 0,
      isLoading: true,
      DivisionTypes: [],
      warehouses: [],
      loadDivisionType: null,
      forceChange: false,
      date_apply: null,
      time_apply: null,
      date_discard: null,
      time_discard: null,
      reasons: [
        { key: 1, value: '相殺' },
        { key: 2, value: '廃棄' },
        { key: 3, value: 'その他' }
      ],
      divisionTypes: [
        { value: 'F', label: '廃棄' },
        { value: 'G', label: '追加' }
      ]
    }
  },

  watch: {
    discardsDetails: {
      handler (v) {
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareDetails(d)
          }
        })

        this.discardsDetails = v
        this.calcGrandTotals()
      },
      deep: true
    }
  },

  created () {
    if (!this.$route.query.discard_id) {
      this.$router.replace('archive-discard')
    }
    this.isLoading = true
    this.discardsID = Number(this.$route.query.discard_id)
    this.$store.dispatch('Master/checkMywarehouses')
    this.$store.dispatch('Master/checkPersonnel')
    this.$store.dispatch('Master/checkPartners')

    Promise.all([
      this.getDiscards()
    ]).then(() => {
      this.popoverButtons()
    }).finally(() => {
      this.isLoading = false
    })
  },

  computed: {
    ...mapState(['currentLanguage']),
    master_personnel () {
      return this.$store.getters['Master/getPersonnel']
    },
    master_partners () {
      return this.$store.getters['Master/getPartners']
    },
    master_mywarehouses () {
      return this.$store.getters['Master/getMywarehouses']
    },
    translatedDivisionTypes () {
      return this.divisionTypes.map(divisionType => {
        return {
          value: divisionType.value,
          label: this.translations(`discard.${divisionType.label}`)
        }
      })
    }
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    quantityKeyUp (event, detail) {
      let { value } = event.target
      value = value.replace(/\D/g, '')
      if (value && value <= 0) value = 1
      detail.quantity = value
      event.target.value = detail.quantity
    },

    divisionRenderText (divisonType) {
      for (let index = 0; index < this.divisionTypes.length; index++) {
        const element = this.divisionTypes[index]
        if (element.value === divisonType) {
          return element.label
        }
      }
      return '-----------'
    },

    numbers (index, target) {
      this.discardsDetails[index][target] = this.discardsDetails[index][target].toString().replace(/[^0-9.-]/g, '')
    },

    displayGrandTotal (val, valIncTax) {
      if (!this.taxIncluded) { // 税抜
        return `${Number(val).toLocaleString()}`
      } else {
        return `${Number(valIncTax).toLocaleString()}`
      }
    },
    toTaxFormat (data, key) {
      if (this.taxIncluded) {
        key = key + '_inctax'
      }
      const price = data[key] || 0
      return Number(price).toLocaleString()
    },

    onchangeTaxclass () {
      this.discardsDetails.forEach((detail, i) => {
        if (typeof detail !== 'undefined') {
          this.discardsDetails[i] = this.prepareDetails(detail)
        }
      })
      this.calcGrandTotals()
    },

    prepareDetails (data) {
      data.total_cost = data.quantity * data.row_price
      data.total_unit_price = data.quantity * data.unit_price
      data.total_profit = data.total_unit_price - data.total_cost

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax = data.total_cost
        data.total_unit_price_inctax = data.total_unit_price
        data.total_profit_inctax = data.total_profit
      } else {
        data.total_cost_inctax = this.$util.getIncludeTax(data.total_cost, data.tax_rate)
        data.total_unit_price_inctax = data.quantity * data.unit_price_inctax
        data.total_profit_inctax = data.total_unit_price_inctax - data.total_cost_inctax
      }

      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalUnitPriceIncTax = 0
      this.grandTotalCost = 0
      this.grandTotalCostIncTax = 0
      this.grandTotalProfit = 0
      this.grandTotalProfitIncTax = 0

      this.discardsDetails.forEach(v => {
        this.grandTotalUnitPrice += Number(v.total_unit_price)
        this.grandTotalCost += Number(v.total_cost)
        this.grandTotalUnitPriceIncTax += Number(v.total_unit_price_inctax)
      })

      this.grandTotalProfit = this.grandTotalUnitPrice - this.grandTotalCost

      this.grandTotalCostIncTax = this.$util.getIncludeTax(this.grandTotalCost, this.taxRate)
      this.grandTotalProfitIncTax = this.grandTotalUnitPriceIncTax - this.grandTotalCostIncTax
    },

    getDiscards () {
      return this.$http.post(this.$api_url.discard_detail, { discard_id: this.discardsID }).then(response => {
        let result = response.data
        if (result.status === true) {
          this.discardInfo = result.information

          this.discardsDetails = result.details
          this.tempInfo = result.information
          this.tempInfo = {
            ...this.tempInfo,
            division_type: this.divisionRenderText(this.tempInfo.division_type)
          }
          this.tempInfo.requester = {
            id: this.tempInfo.requester_id,
            name: this.tempInfo.requester_name
          }
          this.tempInfo.manufacturer = {
            id: this.tempInfo.partner_id,
            name: this.tempInfo.partner_name
          }
          this.tempInfo.warehouse = {
            id: this.tempInfo.warehouse_id,
            name: this.tempInfo.warehouse_name
          }
          this.tempInfo.division_type_select = result.information.division_type
          this.loadDivisionType = result.information.division_type

          this.date_apply = format(new Date(result.information.apply_date), 'yyyy-MM-dd')
          this.time_apply = format(new Date(result.information.apply_date), 'HH:mm')
          this.date_discard = format(new Date(result.information.discard_date), 'yyyy-MM-dd')
          this.time_discard = format(new Date(result.information.discard_date), 'HH:mm')

          return Promise.resolve()
        } else {
          this.$toastr.error(result.message)
          this.$router.push('/archive-discard')
        }
      }).catch(error => {
        console.log('SingleDiscards:getDiscards:catch(error): ', error)
        return Promise.reject(new Error(this.translations('discard.notice_failed')))
      })
    },

    popoverButtons () {
      window.$('button[data-toggle="popover-x"]').each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    /**
     * @param field : orders information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref) {
      let $this = this
      let val = ''
      const rg = /^\s+$/
      if (!value || value === '-' || value === '' || rg.test(value) === true || typeof value === 'undefined') {
        if (field === 'ordered_at') {
          $this.$refs[ref].innerText = '--------------'
        } else {
          $this.$refs[ref].innerText = '--------------'
        }
        val = ''
      } else if (field === 'manufacturer_id') {
        val = 0
        this.master_partners.forEach(function (v) {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'warehouses_id') {
        val = 0
        this.master_mywarehouses.forEach(function (v) {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'requester_id') {
        val = 0
        this.master_personnel.forEach((v) => {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            this.discardInfo.requester_name = v.name
            val = v.id
          }
        })
      } else if (field === 'apply_date' || field === 'discard_date') {
        $this.$refs[ref].innerText = format(new Date(value), 'yyyy/MM/dd HH:mm')
        val = format(new Date(value), "yyyy-MM-dd'T'HH:mm")
      } else if (field === 'division_type') {
        this.discardInfo[field] = value
        this.tempInfo.division_type = this.divisionRenderText(value)
        val = value
      } else {
        this.$refs[ref].innerText = value
        val = value
      }
      this.discardInfo[field] = val
      this.$forceUpdate()
      window.$('#popover-' + ref).popoverX('hide')
    },

    closeModal (ref) {
      if (ref) window.$('#popover-' + ref).popoverX('hide')
    },

    setSelectedRequester (value) {
      this.forceChange = !this.forceChange
      this.tempInfo.request = value
    },

    deleteDetail (i) {
      this.discardsDetails.splice(i, 1)
    },

    updateDiscards () {
      if (!this.discardInfo.apply_date) {
        this.$toastr.warning(this.translations('discard.notice_apply_date'))
        return
      }

      if (!this.discardInfo.discard_date) {
        this.$toastr.warning(this.translations('discard.notice_added_date'))
        return
      }

      if (this.discardInfo.apply_date > this.discardInfo.discard_date) {
        this.$toastr.warning(this.translations('discard.notice_apply_earlier_added_date'))
        return
      }

      if (!this.discardInfo.partner_id) {
        this.$toastr.warning(this.translations('discard.notice_manufacturer'))
        return
      }

      if (!this.discardInfo.warehouse_id) {
        this.$toastr.warning(this.translations('discard.notice_warehouse'))
        return
      }

      if (this.discardsDetails.length === 0) {
        this.$toastr.warning(this.translations('discard.notice_enter_details_line'))
        return
      }

      this.discardInfo.apply_date = format(new Date(this.discardInfo.apply_date), "yyyy-MM-dd'T'HH:mm:ss")
      this.discardInfo.discard_date = format(new Date(this.discardInfo.discard_date), "yyyy-MM-dd'T'HH:mm:ss")
      this.discardsDetails = this.discardsDetails.map(discardsDetail => {
        if (!discardsDetail.product_condition) {
          return {
            ...discardsDetail,
            product_condition: discardsDetail.is_bad ? 1 : (discardsDetail.is_outlet ? 2 : 0)
          }
        }
        return discardsDetail
      })

      this.$dialog.confirm(this.translations('discard.update_discard'), {
        okText: this.translations('common.yes'),
        cancelText: this.translations('common.no')
      }).then(async () => {
        try {
          this.isLoading = true

          const discardInfo = JSON.parse(JSON.stringify(this.discardInfo))

          let paramUpdate = {
            discard_id: this.discardsID,
            information: discardInfo,
            details: this.discardsDetails
          }
          let updateOrder = await this.$http.post(this.$api_url.discard_update, paramUpdate)
          let $data = this.$invoiceTools.prepareResult(updateOrder.data)
          console.log('SingleDiscards:updateDiscards: ', $data)
          if ($data.success === true) {
            this.$toastr.success(this.translations('discard.notice_update_discard_success'), this.translations('common.success'))
            this.discardInfo = JSON.parse(JSON.stringify(discardInfo))
            setTimeout(() => {
              location.reload()
            }, '500')
          } else {
            this.$toastr.error($data.data, this.translations('common.error'))
          }
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          console.log('SingleDiscards:updateDiscards:catch(error): ', error)
          this.$toastr.error(this.translations('discard.notice_update_discard_fail') +
            this.translations('discard.notice_check_error'), this.translations('common.error'))
        }
      })
    },

    deleteDiscards () {
      this.$dialog.confirm(this.translations('discard.delete_discard'), {
        okText: this.translations('common.yes'),
        cancelText: this.translations('common.no')
      })
        .then(async () => {
          this.isLoading = true
          try {
            const response = await this.$http.post(this.$api_url.discard_delete, { discard_id: this.discardsID })
            const result = response.data
            if (result.status === true) {
              this.$toastr.success(this.translations('discard.notice_deleted_discard'), this.translations('common.success'))
              this.$router.replace('archive-discard')
              setTimeout(() => { this.isLoading = false }, 1000)
            } else {
              this.$toastr.warning(result.message)
            }
            this.isLoading = false
          } catch (error) {
            this.isLoading = false
            console.log('SingleDiscards:SingleDiscards:catch(error): ', error)
            this.$toastr.error(this.translations('discard.notice_deleted_discard_fail'), this.translations('common.error'))
          }
        }).catch(() => { console.log('Clicked `Cancel`') })
    },

    clickIsProcessed () {
      this.isLoading = true
      const params = {
        discard_id: this.discardsID,
        is_processed: this.discardInfo.is_processed
      }

      const self = this
      this.$http.post(this.$api_url.discard_update_is_processed, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success(self.translations('discard.notice_processing_status_success'), self.translations('common.success'))
          setTimeout(() => {
            location.reload()
          }, '500')
        } else {
          self.$toastr.warning(response.data.message, self.translations('discard.notice_processing_status_fail'))
          if (response.data.old_is_processed) {
            self.discardInfo.is_processed = response.data.old_is_processed
          }
          self.isLoading = false
        }
      }).finally(function () {
        self.isLoading = false
      })
    },

    openAddDetailModal () {
      if (!this.tempInfo.partner_id) {
        this.$toastr.warning(this.translations('discard.warning_choose_manufacturer'))
      } else if (!this.tempInfo.warehouse_id) {
        this.$toastr.warning(this.translations('discard.warning_choose_warehouse'))
      } else {
        this.$refs.openAddDetailModal.click()
      }
    }
  }
}
</script>

<style>
[for='checkBox'] {
  margin-top: 7px;
  margin-right: 0.6rem;
}
</style>

<style scoped>
textarea {
  resize: both;
}
</style>
